<script setup lang="ts">
type Mode = "list" | "map";

const model = defineModel<Mode>({ required: true });

const props = withDefaults(
  defineProps<{
    tabIdList?: string;
    tabIdMap?: string;
    panelIdList?: string;
    panelIdMap?: string;
  }>(),
  {
    tabIdList: "tab-list",
    tabIdMap: "tab-map",
    panelIdList: "panel-list",
    panelIdMap: "panel-map",
  }
);

const { t } = useI18n();

const tabs = computed(() => [
  {
    value: "list" as const,
    label: t("observations.view.list"),
    icon: "icon:list",
    id: props.tabIdList,
    ariaControls: props.panelIdList,
  },
  {
    value: "map" as const,
    label: t("observations.view.map"),
    icon: "icon:map",
    id: props.tabIdMap,
    ariaControls: props.panelIdMap,
  },
]);
</script>

<template>
  <WebTabs v-model="model" :items="tabs" :ariaLabel="t('observations.view.label')" class="max-lg:hidden" />
</template>
